import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import { resourcesPageTplData } from "../data/page-tpl-resources.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import ButtonText from "../components/ButtonText";
import PageHead from "../components/Page/PageHead";
import AccordionLinksSection from "../components/AccordionLinksSection";
import Hero from "../componentsSections/Hero";
import { VectorBackground } from "../components/VectorBackground";
import GenericWideSection from "../components/GenericWideSection";

const pageResources = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = resourcesPageTplData(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            {/* SEO Metas */}
            <Seo post={seoPageData} />
            {/* Page hero */}
            <Hero {...pageData.hero} textSize="big" />
            {/* Page head */}
            <Section className="-small-margin-bottom"></Section>

            <Container>
                <PageHead
                    className="-max-width-750"
                    title={pageData.pageHeader.header}
                    text={pageData.pageHeader.text}
                />
            </Container>

            {/* Resources Section */}
            <Section className="-margin-bottom-tiny">
                <div className="resources color-wrapper-resources container-wide ">
                    <VectorBackground gradient />
                    <Container>
                        {pageData.button?.link && (
                            <Section className="mb-5">
                                <ButtonText
                                    variant="red"
                                    {...pageData.button.link}
                                >
                                    {pageData.button.link.title}
                                </ButtonText>
                            </Section>
                        )}
                        {/* <AccordionLinksSection
                            {...pageData.generalInformation}
                            id="general-information"
                            containerClassName="px-0 -border-bottom"
                        /> */}
                        <AccordionLinksSection
                            {...pageData.guides}
                            id="quick-guides"
                        />
                        <AccordionLinksSection
                            {...pageData.docs}
                            id="documentation"
                            className="px-0 "
                        />
                    </Container>
                </div>
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default pageResources;
